var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanquetSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 55,
    fill: "none",
    viewBox: "0 0 62 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.214,
    cy: 2.762,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.038,
    cy: 5.523,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.72,
    cy: 12.887,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.8,
    cy: 20.251,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.356,
    cy: 25.774,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.532,
    cy: 25.774,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.088,
    cy: 20.251,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.707,
    cy: 12.887,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.85,
    cy: 5.523,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.214,
    cy: 14.728,
    r: 7.824,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.536,
    cy: 3.107,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.36,
    cy: 5.868,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.042,
    cy: 13.232,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.122,
    cy: 20.596,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.678,
    cy: 26.119,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.854,
    cy: 26.119,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.41,
    cy: 20.596,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.03,
    cy: 13.232,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.172,
    cy: 5.868,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.536,
    cy: 15.073,
    r: 7.824,
    fill: "#D9D9D9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.184,
    cy: 29.226,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.009,
    cy: 31.988,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.691,
    cy: 39.352,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.77,
    cy: 46.716,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.326,
    cy: 52.239,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.502,
    cy: 52.239,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.059,
    cy: 46.716,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.678,
    cy: 39.352,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.821,
    cy: 31.988,
    r: 2.762,
    fill: "#D9D9D9"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.185,
    cy: 41.193,
    r: 7.824,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanquetSpace);
export default __webpack_public_path__ + "static/media/banquet-space.159b6bcf00e25e4785bca8125b3b965a.svg";
export { ForwardRef as ReactComponent };